import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import MediaObject from 'components/MediaObject';
import ModalTrigger from 'components/ModalTrigger';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingSelfServeAddChildAccountModal from 'coaching/components/CoachingSelfServeView/CoachingSelfServeAddChildAccountModal';
import { GetCoachingHomeDashboard_coaching_coachingHomeDashboard_participants as Participant } from 'coaching/queries/__generated__/GetCoachingHomeDashboard';
import { getFirstNameLastInital } from 'coaching/lib/nameFormat';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';

export type Props = {
  participant: Participant;
};

export default function CoachingHomeParticipantSectionHeader({ participant }: Props) {
  const SectionHeaderComponent = userAgent.isDesktop() ? SectionHeaderInline : SectionHeaderStacked;
  return (
    <Row size="small">
      <SectionHeaderComponent participant={participant} />
    </Row>
  );
}

function SectionHeaderInline({ participant }: Props) {
  return (
    <MediaObject gutter="small" center>
      <Heading flush>{getFirstNameLastInital(participant.participantMetadata.studentName)}</Heading>
      <StudentInvitationDetails participant={participant} />
    </MediaObject>
  );
}

function SectionHeaderStacked({ participant }: Props) {
  return (
    <>
      <Heading>{getFirstNameLastInital(participant.participantMetadata.studentName)}</Heading>
      <StudentInvitationDetails participant={participant} />
    </>
  );
}

function StudentInvitationDetails({ participant }: Props) {
  const hasConnectedStudent = !!participant.participantMetadata.studentUuid;
  if (hasConnectedStudent) {
    return null;
  }

  // Store the student's email on add, so we can update immediately to "Pending invitation sent"
  const [sentToEmail, setSentToEmail] = React.useState<string | null>(null);
  const email = participant.studentInvitation?.studentEmail ?? sentToEmail;
  return (
    <span data-test="student-invitation-details">
      {email ? (
        <Text size="xsmall" color="graphite" data-test="pending-invitation-text">
          Pending invitation for <strong>{email}</strong>
        </Text>
      ) : (
        <ModalTrigger
          modal={
            <CoachingSelfServeAddChildAccountModal
              onRequestHide={() => { }}
              onAddChild={setSentToEmail}
              participantUUID={participant.uuid}
              currentUserEmail={CurrentUser.getUser().getEmail()}
              eventKeyScreen="self_schedule_purchase"
            />
          }>
          <Button level="icon" data-test="add-child-button">
            <MediaObject gutter="xsmall">
              <Icon name="avatar-add-stroked" />
              Invite student
            </MediaObject>
          </Button>
        </ModalTrigger>
      )}
    </span>
  );
}
